<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" *ngIf="!oneLine">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
    <img src="../../../assets/img/logos/Provalt_Jura_png.png" style="max-width: 100%" alt="Provalt Jura"/>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <img src="../../../assets/img/logos/Provalt_Savoie_png.png" style="max-width: 100%" alt="Provalt Savoie"/>
  </div>
</div>


<div class="row" *ngIf="oneLine">
  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
    <img src="../../../assets/img/logos/Provalt_Jura_png.png" style="max-width: 100%" alt="Provalt Jura"/>
  </div>

  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
    <img src="../../../assets/img/logos/Provalt_Savoie_png.png" style="max-width: 100%" alt="Provalt Savoie"/>
  </div>
</div>
